import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles handle_video_alerts tool - opens vsi ai alerts dashboard in a new tab
 */
export const handleVSIAiAlerts = (options: HandlerOptions): void => {
  try {
    const { args, baseUrl } = options;
    const { alertId } = args || {};
    const showSummaryDashboard = alertId ? false : true;
    const url = showSummaryDashboard
      ? `${baseUrl}/dashboard/ai-alerts`
      : `${baseUrl}/dashboard/ai-alerts/pre-diagnostics/${alertId}`;

    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'vsi_ai_alerts', url });
      logger.log('Opened ai alerts in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling ai alerts:', error);
  }
};
